import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";

type LandingPageArticleProps = {
  /** The details of article to render on landing page*/
  articleProps: ComponentProps<typeof Card>;
};

/**
 * Component to render Article card on events awards landing page
 */
const LandingPageArticle = ({
  articleProps,
}: LandingPageArticleProps): React.ReactElement => {
  const variant: CardVariations = {
    title: {
      color: "black",
      size: "text-6xl",
      extraClass: "font-public-sans font-semibold mt-5 lg:mt-1 lg:mb-1",
    },
    kicker: {
      color: "text-gray-515",
      extraClass: "pt-4 lg:pt-0 font-public-sans",
    },
    image: {
      width: "w-full lg:w-1/2",
      position: "left",
      aspectRatio: "object-cover",
    },
    content: {
      width: "w-full lg:w-1/2",
      extraClass: "px-4 pr-0 text-left lg:pl-4",
      blurb: {
        extraClass: "text-gray-750 font-sans",
      },
    },
  };

  return (
    <div
      className="flex-flex-wrap mb-5 w-full text-center lg:mx-auto lg:w-10/12"
      data-testid="landing-page-article-component"
    >
      <Card
        {...articleProps}
        className="mx-0 mt-4 justify-center pb-8 pt-4"
        variations={variant}
      />
    </div>
  );
};

export default LandingPageArticle;
